export var TRIGGER_MOMENT = {
  ON_LOAD: '1',
  ON_CLICK: '2',
  ON_MIDDLE: '3',
  AFTER_LOAD: '4',
  NOT_SHOW: '5'
};
export var TRIGGER_WAY = {
  ALL: '0',
  SPECIFIC: '1',
  CUSTOMIZED: '2'
};
export var STATUS = {
  OPEN: 1,
  CLOSE: 0
};
export var SCHEMA_TYPE = {
  PAGEDIALOG: 'pageDialog',
  WALLHANGING: 'wallHanging'
};
export var ASSOCIATETYPE = {
  INCLUDES: 'includes',
  EQUAL: 'equal',
  NOTNULL: 'notNull'
};
export var SHOW_SHAPE = {
  SCORE: '1',
  STAR: '2',
  HEART: '3',
  LIKE: '4',
  FACE: '5'
};